import { createContext } from 'react'

export const MonopolyContext = createContext(null)
